const sortConfig = [
    {
        label: 'Laatst toegevoegd',
        value: 'recent-desc',
        isDefault: false
    },
    {
        label: 'Prijs (laag-hoog)',
        value: 'price-asc',
        isDefault: true
    },
    {
        label: 'Prijs (hoog-laag)',
        value: 'price-desc',
        isDefault: false
    },
    {
        label: 'Kilometerstand (laag-hoog)',
        value: 'mileage-asc',
        isDefault: false
    },
    {
        label: 'Kilometerstand (hoog-laag)',
        value: 'mileage-desc',
        isDefault: false
    },
    {
        label: 'Bouwjaar (oud - nieuw)',
        value: 'year-asc',
        isDefault: false
    },
    {
        label: 'Bouwjaar (nieuw - oud)',
        value: 'year-desc',
        isDefault: false
    }
];

export default sortConfig;
